import React from "react";
import Chart from "react-apexcharts";

// Palet warna global (bisa dipakai di donut dan bar chart)
const chartColors = [
    "#0071CE", "#F7941E", "#2ECC71", "#E74C3C", "#9B59B6",
    "#1ABC9C", "#F1C40F", "#34495E", "#E67E22", "#7F8C8D"
];

const ExportBarChart = ({ data, kategori, orderBy, limit }) => {
    const fieldMap = {
        negara: "negara_tujuan",
        upt: "nama_upt",
        trader: "nama_trader",
        kel_ikan: "kel_ikan",
    };

    const labelMapKategori = {
        negara: "Negara Tujuan Ekspor",
        upt: "Unit Pelaksana Teknis",
        trader: "Eksportir",
        kel_ikan: "Komoditas",
    };

    const labelMapBerdasarkan = {
        jumlah: "Frekuensi",
        netto: "Volume (Ton)",
        nilaiIDR: "Nilai Rupiah (Juta)",
        nilaiUSD: "Nilai USD",
    };

    const labelField = fieldMap[kategori] || "kategori_tak_dikenal";
    const dataField = orderBy || "jumlah";
    const labelKategori = labelMapKategori[kategori] || kategori;
    const labelOrderBy = labelMapBerdasarkan[orderBy] || orderBy;

    if (!data || data.length === 0) {
        return <p className="text-center">Tidak ada data untuk ditampilkan.</p>;
    }

    const convertValue = (val) => {
        val = +val || 0;
        if (orderBy === "netto") return +(val / 1000).toFixed(2);         // kg → ton
        if (orderBy === "nilaiIDR") return +(val / 1_000_000).toFixed(2); // IDR → juta
        return val;
    };

    const formatValue = (val) => {
        const options = { minimumFractionDigits: 2, maximumFractionDigits: 2 };
        if (orderBy === "nilaiIDR") return `Rp ${val.toLocaleString("id-ID", options)} JUTA`;
        if (orderBy === "nilaiUSD") return `$ ${val.toLocaleString("id-ID", options)}`;
        if (orderBy === "netto") return `${val.toLocaleString("id-ID", options)} TON`;
        return `${val.toLocaleString("id-ID")} dokumen`;
    };

    const xCategories = data.map(item => item[labelField] || "(Tidak diketahui)");
    const seriesData = data.map(item => convertValue(item[dataField]));

    const chartOptions = {
        chart: {
            type: 'bar',
            height: 400,
            toolbar: { show: true }
        },
        plotOptions: {
            bar: {
                horizontal: true,
                barHeight: '50%',
                borderRadius: 5,
                distributed: true, // enable warna per-bar
            },
        },
        title: {
            text: `GRAFIK TOP ${limit} EKSPOR KATEGORI ${labelKategori.toUpperCase()} BERDASARKAN ${labelOrderBy.toUpperCase()}`,
            align: 'center',
        },
        xaxis: {
            categories: xCategories,
            title: { text: labelOrderBy },
            labels: {
                style: { fontSize: '12px' },
                formatter: (val) => val.toLocaleString("id-ID"),
            }
        },
        yaxis: {
            title: {
                text: labelKategori,
                style: { fontWeight: 'bold' },
                margin: 30,
            },
            labels: {
                style: { fontSize: '12px' },
                trim: false,
                maxWidth: 400,
                formatter: (val) =>
                    val.length > 30 ? val.slice(0, 30) + '\n' + val.slice(30) : val,
            }
        },
        tooltip: {
            y: {
                formatter: formatValue
            }
        },
        dataLabels: {
            enabled: false
        },
        colors: chartColors // gunakan palet yang sama dengan donut
    };

    const chartSeries = [
        {
            name: labelOrderBy,
            data: seriesData
        }
    ];

    return <Chart options={chartOptions} series={chartSeries} type="bar" height={400} />;
};

export default ExportBarChart;

// Agar konsisten, array `chartColors` ini juga bisa diimpor di custom-donut-chart.js
export { chartColors };
